import React from 'react';
import { styled } from '@vw-marketing/us-components';

interface FiveStarsProps {
  background?: string;
  starColor?: string;
  starSize?: string;
  percent?: number;
}

const Stars: any = styled.div<FiveStarsProps>`
  ${(props: any) => `

  .star-rating-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: -0.11em 0 0.11em 0 ;
    font-family: 'Semibold', sans-serif;
    color: @color-11;
    font-size: 14px;
    line-height: 20px;

    .star-ratings {
      font-size: 20px;
      display: inline-block;
  color: ${props.background};
  font-size: ${props.starSize};
  position: relative;
  font-family: ${props.theme.fonts.headline[600]?.fontFamily};
  letter-spacing: 3px;
  // IE only styles
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    font-family: Times;
  }

  span:before {
    content: '★';

    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      content: '★';
    }
  }

  &-top {
    width: ${props.percent}%;
    color: ${props.starColor};
    position: absolute;
    z-index: 1;
    display: block;
    top: 0;
    left: 0;
    overflow: hidden;
    height: 100%;
  }

  &-bottom {
    display: block;
    z-index: 0;
  }
    }

  }
`}
`;
const FiveStars: React.FC<FiveStarsProps> = props => {
  return (
    <Stars {...props}>
      <div className="star-rating-container">
        <div className="star-ratings">
          <div className="star-ratings-top">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="star-ratings-bottom">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </Stars>
  );
};

export default FiveStars;
